<template>
  <b-container class="h-100">
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <div class="text-center my-4">
          <h2 class="h1">Kalkulácie</h2>
          <h3>Jednoducho a rýchlo si vypočítajte náklady na energie.</h3>
          <h4 class="text-muted font-weight-normal">
            Ak požadujete dosiahnuť najpresnejší výsledok, zadávajte správne
            hodnoty odberných miest „OM“ ku ktorým plánujete výpočet.<br />
            Zvoľte o aký typ Kalkulačky máte záujem.
          </h4>
        </div>
        <b-row align-h="center">
          <b-col cols="12" sm="6" md="5">
            <div class="mb-4">
              <div class="tile-base mb-4">
                <div class="tile-icon lg shadow-lg mb-4">
                  <icon class="icon-fw text-power" name="plug" scale="3" />
                </div>
                <h4 class="h2 tile-header text-uppercase">Elektrina</h4>
              </div>
              <div class="pt-3">
                <b-list-group
                  class="list-group-anim bg-white w-caret caret-top"
                >
                  <b-list-group-item
                    :to="{
                      name: 'calculatorView',
                      params: { energetic: 'power', type: 'reserved-capacity' },
                    }"
                  >
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <b-icon icon="graph-up" font-scale="2" />
                      </div>
                      <div class="flex-grow-1 text-center">
                        <h4 class="text-power mb-1">
                          Výpočet rezervovanej kapacity "RK"
                        </h4>
                        Nastavte si výkon pre Vaše odberné miesto
                      </div>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    :to="{
                      name: 'calculatorView',
                      params: { energetic: 'power', type: 'advance-payment' },
                    }"
                  >
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <b-icon icon="list-check" font-scale="2" />
                      </div>
                      <div class="flex-grow-1 text-center">
                        <h4 class="text-power mb-1">
                          Výpočet zálohovej platby
                        </h4>
                        Vypočítajte si Váš budúci rozpočet (budget)
                      </div>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    :to="{
                      name: 'calculatorView',
                      params: { energetic: 'power', type: 'breaker-recalc' },
                    }"
                  >
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <b-icon icon="arrow-left-right" font-scale="2" />
                      </div>
                      <div class="flex-grow-1 text-center">
                        <h4 class="text-power mb-1">
                          Prepočet hlavného ističa na RK
                        </h4>
                        Prepočet hodnoty hlavného ističa (A) na rezervovanú
                        kapacitu (kW) a opačne
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" md="5">
            <div class="mb-4">
              <div class="tile-base mb-4">
                <div class="tile-icon lg shadow-lg mb-4">
                  <icon class="icon-fw text-gas" name="fire" scale="3" />
                </div>
                <h4 class="h2 tile-header text-uppercase">Plyn</h4>
              </div>
              <div class="pt-3">
                <b-list-group
                  class="list-group-anim bg-white w-caret caret-top"
                >
                  <b-list-group-item
                    :to="{
                      name: 'calculatorView',
                      params: { energetic: 'gas', type: 'daily-max' },
                    }"
                  >
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <b-icon icon="graph-up" font-scale="2" />
                      </div>
                      <div class="flex-grow-1 text-center">
                        <h4 class="text-gas mb-1">
                          Výpočet denného maximálneho množstva "DMM"
                        </h4>
                        Nastavte si výkon pre Vaše odberné miesto
                      </div>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    :to="{
                      name: 'calculatorView',
                      params: { energetic: 'gas', type: 'advance-payment' },
                    }"
                  >
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <b-icon icon="list-check" font-scale="2" />
                      </div>
                      <div class="flex-grow-1 text-center">
                        <h4 class="text-gas mb-1">Výpočet zálohovej platby</h4>
                        Vypočítajte si Váš budúci rozpočet (budget)
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  data: function () {
    return {
      collapsed: {
        power: false,
        gas: false,
      },
    }
  },
}
</script>
